import { compareSemver } from './semver';

export function isSparkJsVersionAtLeast(version: string | null | undefined, min: string): boolean {
  if (!version) return false;
  if (version === 'latest') return true;
  const comparison = compareSemver(version, min);
  return comparison !== null && comparison >= 0;
}
